interface PageHeadingProps {
    title?: string;
    subTitle?: string;
}

function PageHeading({ title, subTitle }: PageHeadingProps) {
    const Heading = () => {
        if (!title) return null;
        return (
            <div className="font-primary text-lg font-semibold text-gray-700">
                {title}
            </div>
        );
    };

    const SubHeading = () => {
        if (!subTitle) return null;
        return (
            <div className="font-primary text-sm font-normal text-gray-700">
                {subTitle}
            </div>
        );
    };
    return (
        <div>
            <Heading />
            <SubHeading />
        </div>
    );
}

export default PageHeading;
